import { render, staticRenderFns } from "./SecurityMeasures.vue?vue&type=template&id=bda62ed8&scoped=true"
import script from "./SecurityMeasures.vue?vue&type=script&lang=js"
export * from "./SecurityMeasures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bda62ed8",
  null
  
)

export default component.exports